// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-layout:not(.form-layout--no-padding) {
  padding: var(--base-sizes-4);
  padding-bottom: var(--base-sizes-6);
}

.form-layout > header {
  margin-bottom: var(--base-sizes-8);
}

.form-layout > header > h2 {
  margin-top: var(--base-sizes-0);
  margin-bottom: var(--base-sizes-1);
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: var(--base-font-weight-regular);
}

.form-layout > header > p {
  font-size: .875rem;
  line-height: 1.25rem;
  font-weight: var(--base-font-weight-regular);
}

.form-layout > header > p:last-child {
  margin-bottom: var(--base-sizes-0);
}

.form-layout > footer {
  margin-top: var(--base-sizes-2);
}

.form-layout.form-layout--full-footer-space > footer {
  margin-top: var(--base-sizes-8);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormLayout/FormLayout.css","webpack://./services/frontend/app/components/FormLayout/FormLayout.css"],"names":[],"mappings":"AADA;ECEE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".form-layout:not(.form-layout--no-padding) {\n    padding: var(--base-sizes-4);\n    padding-bottom: var(--base-sizes-6)\n}\n  .form-layout > header {\n    margin-bottom: var(--base-sizes-8)\n}\n  .form-layout > header > h2 {\n    margin-top: var(--base-sizes-0);\n    margin-bottom: var(--base-sizes-1);\n    font-size: 1.5rem;\n    line-height: 2rem;\n    font-weight: var(--base-font-weight-regular)\n}\n  .form-layout > header > p {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    font-weight: var(--base-font-weight-regular)\n}\n  .form-layout > header > p:last-child {\n    margin-bottom: var(--base-sizes-0)\n}\n  .form-layout > footer {\n    margin-top: var(--base-sizes-2)\n}\n  .form-layout.form-layout--full-footer-space > footer {\n    margin-top: var(--base-sizes-8)\n}\n",".form-layout:not(.form-layout--no-padding) {\n  padding: var(--base-sizes-4);\n  padding-bottom: var(--base-sizes-6);\n}\n\n.form-layout > header {\n  margin-bottom: var(--base-sizes-8);\n}\n\n.form-layout > header > h2 {\n  margin-top: var(--base-sizes-0);\n  margin-bottom: var(--base-sizes-1);\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: var(--base-font-weight-regular);\n}\n\n.form-layout > header > p {\n  font-size: .875rem;\n  line-height: 1.25rem;\n  font-weight: var(--base-font-weight-regular);\n}\n\n.form-layout > header > p:last-child {\n  margin-bottom: var(--base-sizes-0);\n}\n\n.form-layout > footer {\n  margin-top: var(--base-sizes-2);\n}\n\n.form-layout.form-layout--full-footer-space > footer {\n  margin-top: var(--base-sizes-8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
